import * as React from "react";
const SvgTreeIcon = props => <svg width="1em" height="1em" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M7.563 7.996H.787V.8h.406v6.79h6.37v.406Z" fill="#000" fillOpacity={0.88} /></svg>;
export default SvgTreeIcon;